/**
 * The ages people actually advertise events for.
 *
 * <p>A free number box let you type 16 and sit there wondering what to do next, and made "any"
 * something you had to clear a field to express. A fixed list makes both ends obvious and the
 * open-ended case a first-class choice.
 *
 * <p>Fives up to 60, matching how organisers band their events ("Over 35s", "25-35"); beyond that
 * the distinctions stop being meaningful for this kind of listing.
 */
export const AGE_OPTIONS: number[] = [18, 20, 25, 30, 35, 40, 45, 50, 55, 60];

/** The label for an unbounded end of the range. */
export const ANY_AGE = '';
